// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const IS_SOLD_POLL_BUTTON_NO = "Nie";
export const IS_SOLD_POLL_BUTTON_YES = "\u00c1no, vec som predala cez Kon\u00edka";
export const IS_SOLD_POLL_NOTE = "ak si inzer\u00e1t predala cez in\u00fa str\u00e1nku, darovala, vyhodila, (...), \u0165ukni Nie";
export const IS_SOLD_POLL_TITLE = "Predala si t\u00fato vec cez Kon\u00edka?";
